import * as Types from './types';
import { actionTypes } from './constants';
import { IGamesFeed } from '../types';
import { IGamesConfiguration } from '../hooks/useGetGamesConfiguration/types';

export const updateGamesConfiguration = (data: IGamesConfiguration): Types.IUpdateGamesConfigurationAction => ({
    type: actionTypes.GAMES_CONFIGURATION_UPDATE,
    payload: data
});

export const addGamesFeed = (gamesFeed: IGamesFeed): Types.IAddGamesFeedAction => ({
    type: actionTypes.GAMES_CONFIGURATION_GAMES_FEED_ADD,
    payload: gamesFeed
});

export const setGamesFavorites = (gameCodes: string[]): Types.ISetGamesFavoritesAction => ({
    type: actionTypes.GAMES_FAVORITES_SET,
    payload: gameCodes
});

export const toggleFavoriteGame = ({ gameCodes, isFavorite }: {
    gameCodes: string[]; isFavorite: boolean;
}): Types.IToggleFavoriteGameAction => ({
    type: actionTypes.GAMES_FAVORITES_TOGGLE,
    payload: { gameCodes, isFavorite }
});
